import Swiper from 'swiper/dist/js/swiper';
import $ from 'jquery';

import ShowIcon from './ShowIcon';

export default class {
  constructor($c) {
    const container = $c.find('.js-why-container');
    const prev = $c.find('.js-why-prev');
    const next = $c.find('.js-why-next');

    this.swiper = new Swiper(container, {
      navigation: { prevEl: prev, nextEl: next },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      loop: true
    });

    this.swiper.on('slideChange', () => {
      const $currentSlide = $(this.swiper.slides[this.swiper.activeIndex]);
      ShowIcon.toggleIcon($currentSlide, true);
    });

    $c.on('click', '.js-why-next-title', (e) => {
      e.preventDefault();
      this.swiper.slideNext();
    });
  }
}
